import { useEffect } from 'react';

import usePathname from 'app-migration/hooks/usePathname';

import { useStores } from './use-stores';

const useCryptoExternalSources = () => {
    const { uiStore, externalSourcesStore } = useStores();

    const pathname = usePathname();
    const pathnameSplit = !!pathname ? pathname.split('/') : [];

    // Check watchlist view
    const isWatchlistFinancialsView = uiStore.watchlistView === 'financials' && !uiStore.watchlistCollapsed;

    // Check if it's a crypto page
    const isCryptoPage = ['/events/crypto', '/live/crypto', '/watchlist'].includes(pathname);

    // Check if it's a crypto market
    const isMarket = pathnameSplit.length > 2 && pathnameSplit[1] === 'markets';
    const isBtcMarket = isMarket && pathnameSplit[2].includes('btc');
    const isEthMarket = isMarket && pathnameSplit[2].includes('eth');

    // Check if we want to load the data
    const loadBtcData = isWatchlistFinancialsView || isCryptoPage || isBtcMarket;
    const loadEthData = isWatchlistFinancialsView || isCryptoPage || isEthMarket;

    // Blocker to stop polling
    const isExternalCharts =
        pathnameSplit.length > 2 && pathnameSplit[1] === 'charts' && pathnameSplit[2] === 'external';
    const isHome = pathname === '/';
    const blockStopPolling = isExternalCharts || isHome;

    useEffect(
        () => {
            if (loadBtcData) {
                externalSourcesStore.loadExternalSourceSeries('crypto', 'BTC', 'slow');
                externalSourcesStore.loadExternalSourceLastValue('crypto', 'BTC', 'fast');
            }

            if (loadEthData) {
                externalSourcesStore.loadExternalSourceSeries('crypto', 'ETH', 'slow');
                externalSourcesStore.loadExternalSourceLastValue('crypto', 'ETH', 'fast');
            }

            return (): void => {
                if (!blockStopPolling) {
                    externalSourcesStore.stopPollingCrypto();
                }
            };
        }, // TODO: check or fix hooks error
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [loadBtcData, loadEthData],
    );
};

export default useCryptoExternalSources;
